module.exports = __webpack_public_path__ + "img/OSDi-Claim_negativ_RGB.d6d8e4c0.svg";